import React, { useEffect, useState } from "react";
import Processing from "./processing";
import Success from "./success";
import { apis, post } from "../../../../../../Utils/axios";
import { useLocation } from "react-router-dom";
import { Toast } from "../../../../../../Components";
import BookingFailed from "./failed";
import BookingPending from "./pending";

const BOOKING_TIMEOUT_MS = 5 * 60 * 1000;
const getFailedBookingState = (error) => ({
	status: "FAILED",
	bookingId: error?.response?.data?.bookingId || error?.response?.data?.booking?.bookingId || error?.response?.data?.booking?.id,
	error: error?.response?.data?.error || error?.message || "Something went wrong while confirming your booking.",
});

function ConfirmBooking() {
	const LOCATION = useLocation();
	const { selectedFlightOptionKey, logo, name, code, approvalId, requestId, customFields, costCenterId, passengers, paymentMode, date, from, to, airline, flightNumber, flightType } = LOCATION.state || {};

	const [Booking, setBooking] = useState();

	useEffect(() => {
		if (selectedFlightOptionKey) bookFlight();
	}, []);

	const bookFlight = () => {
		setBooking();
		post(
			apis.bookFlight,
			{
				requestId,
				approvalId,
				customFields,
				costCenterId,
				passengers,
				paymentMode,
				selectedFlightOptionKey,
				date,
				from,
				to,
				airline,
				flightNumber,
				flightType,
			},
			(r, e) => {
				//clear the location state
				window.history.replaceState({}, "", window.location.pathname);
				if (r?.booking) {
					setBooking(r.booking);
					//Clear the location state
				} else if (e) {
					Toast.handleError(e);
					setBooking(getFailedBookingState(e));
				}
			},
			{ timeout: BOOKING_TIMEOUT_MS }
		);
	};

	if (Booking?.status === "BOOKED") return <Success booking={Booking} />;
	if (Booking?.status === "FAILED") return <BookingFailed booking={Booking} />;
	if (Booking?.status === "PENDING") return <BookingPending booking={Booking} />;
	return <Processing flight={{ logo, name, code }} />;
}

export default ConfirmBooking;
